import { render } from "./FeaturedList.vue?vue&type=template&id=6762737c"
import script from "./FeaturedList.vue?vue&type=script&lang=js"
export * from "./FeaturedList.vue?vue&type=script&lang=js"

import "./FeaturedList.vue?vue&type=style&index=0&id=6762737c&lang=css"

import exportComponent from "/var/www/staging.no-menu.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__